
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { useSearchParams } from "react-router-dom";

export function FilterSection() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [type, setType] = useState(searchParams.get("type") || "");
  const [paymentMethod, setPaymentMethod] = useState(searchParams.get("paymentMethod") || "");
  const [paymentStatus, setPaymentStatus] = useState(searchParams.get("paymentStatus") || "");
  const [startDate, setStartDate] = useState(searchParams.get("startDate") || "");
  const [endDate, setEndDate] = useState(searchParams.get("endDate") || "");
  const [isFixedExpense, setIsFixedExpense] = useState(searchParams.get("isFixedExpense") || "");
  const [isFilterExpanded, setIsFilterExpanded] = useState(false);

  // Sync state with URL params on mount and when params change
  useEffect(() => {
    setType(searchParams.get("type") || "");
    setPaymentMethod(searchParams.get("paymentMethod") || "");
    setPaymentStatus(searchParams.get("paymentStatus") || "");
    setStartDate(searchParams.get("startDate") || "");
    setEndDate(searchParams.get("endDate") || "");
    setIsFixedExpense(searchParams.get("isFixedExpense") || "");
  }, [searchParams]);

  const handleFilter = () => {
    const params = new URLSearchParams();
    if (type) params.set("type", type);
    if (paymentMethod) params.set("paymentMethod", paymentMethod);
    if (paymentStatus) params.set("paymentStatus", paymentStatus);
    if (startDate) params.set("startDate", startDate);
    if (endDate) params.set("endDate", endDate);
    if (isFixedExpense) params.set("isFixedExpense", isFixedExpense);
    setSearchParams(params);
    
    // On mobile, collapse the filter section after applying
    if (window.innerWidth < 768) {
      setIsFilterExpanded(false);
    }
  };

  const handleClearFilters = () => {
    setType("");
    setPaymentMethod("");
    setPaymentStatus("");
    setStartDate("");
    setEndDate("");
    setIsFixedExpense("");
    setSearchParams({});
  };

  const toggleFilterExpand = () => {
    setIsFilterExpanded(!isFilterExpanded);
  };

  return (
    <div className="space-y-3 sm:space-y-4 bg-[#1A1F2C] rounded-lg p-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-4">
        <div className="flex items-center w-full sm:w-auto justify-between">
          <h2 className="text-base sm:text-lg font-semibold text-white">Filtros</h2>
          <button 
            className="sm:hidden text-[#8A9099] hover:text-white"
            onClick={toggleFilterExpand}
          >
            {isFilterExpanded ? "▲ Ocultar" : "▼ Expandir"}
          </button>
        </div>
        <Button
          variant="outline"
          onClick={handleClearFilters}
          className="text-[#8A9099] hover:text-white hover:bg-[#222831] w-full sm:w-auto"
        >
          Limpar Filtros
        </Button>
      </div>
      
      <div className={`${isFilterExpanded || window.innerWidth >= 768 ? 'grid' : 'hidden sm:grid'} grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-2 sm:gap-4 transition-all duration-300`}>
        <Select value={type} onValueChange={setType}>
          <SelectTrigger className="bg-[#222831] text-white border-[#404040]">
            <SelectValue placeholder="Tipo" />
          </SelectTrigger>
          <SelectContent className="bg-[#1A1F2C] text-white border-[#404040] z-50">
            <SelectItem value="entrada">Entrada</SelectItem>
            <SelectItem value="saida">Saída</SelectItem>
            <SelectItem value="despesas">Despesa Fixa</SelectItem>
          </SelectContent>
        </Select>

        <Select value={paymentMethod} onValueChange={setPaymentMethod}>
          <SelectTrigger className="bg-[#222831] text-white border-[#404040]">
            <SelectValue placeholder="Método de Pagamento" />
          </SelectTrigger>
          <SelectContent className="bg-[#1A1F2C] text-white border-[#404040] z-50">
            <SelectItem value="pix">PIX</SelectItem>
            <SelectItem value="dinheiro">Dinheiro</SelectItem>
            <SelectItem value="cartao">Cartão</SelectItem>
          </SelectContent>
        </Select>

        <Select value={paymentStatus} onValueChange={setPaymentStatus}>
          <SelectTrigger className="bg-[#222831] text-white border-[#404040]">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent className="bg-[#1A1F2C] text-white border-[#404040] z-50">
            <SelectItem value="pago">Pago</SelectItem>
            <SelectItem value="pendente">Pendente</SelectItem>
            <SelectItem value="atrasado">Atrasado</SelectItem>
          </SelectContent>
        </Select>
        
        <Select value={isFixedExpense} onValueChange={setIsFixedExpense}>
          <SelectTrigger className="bg-[#222831] text-white border-[#404040]">
            <SelectValue placeholder="Despesa Fixa" />
          </SelectTrigger>
          <SelectContent className="bg-[#1A1F2C] text-white border-[#404040] z-50">
            <SelectItem value="true">Sim</SelectItem>
            <SelectItem value="false">Não</SelectItem>
          </SelectContent>
        </Select>

        <Input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="bg-[#222831] text-white border-[#404040]"
          placeholder="Data Inicial"
        />

        <Input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="bg-[#222831] text-white border-[#404040]"
          placeholder="Data Final"
        />
      </div>
      <div className="flex justify-end mt-4">
        <Button
          onClick={handleFilter}
          className="bg-[#0073B7] hover:bg-[#004080] text-white w-full sm:w-auto"
        >
          Aplicar Filtros
        </Button>
      </div>
    </div>
  );
}
